import React from "react";
import web1 from "../Assets/web1.png";
import web2 from "../Assets/web2.png";
import web3 from "../Assets/web3.png";
const Portofolio = () => {
  return (
    <section id="portofolio">
      <div className="pt-36 pb-32 bg-cplight">
        <div className="container">
          <div className="max-w-5xl mx-auto text-center mb-8 md:px-14" data-aos="fade-up"  data-aos-duration="1500">
            <h4 className="font-bold text-sm uppercase text-cpdark mb-2 lg:text-base">
              Portofolio
            </h4>
            <h2 className="font-semibold text-xl text-cpdark uppercase lg:text-3xl ">
              Project terbaru saya{" "}
            </h2>
            <p className="font-normal text-sm text-center text-secondary mt-2 lg:text-base">
              Berikut adalah beberapa projek yang telah saya selesaikan dan saya
              kan terus belajar lagi agar saya dapat mengembangkan skills saya
              pada bidang ini
            </p>
          </div>
          <div className="w-full flex flex-wrap justify-center xl:w-10/12 xl:mx-auto">
            <div className="mb-5 p-4 md:w-1/2" > 
              <div className="rounded-md shadow-md overflow-hidden"  data-aos="zoom-in" data-aos-duration="1200">
                <img src={web1} alt="Web Movies" width="w-full" />
              </div>
              <h3 className="font-semibold text-base text-dark uppercase mt-4 mb-1 lg:text-2xl" data-aos="fade-up"  data-aos-duration="2000">
                  Aqadnica
              </h3>
              <p className="font-normal text-sm text-secondary text-justify lg:text-base" data-aos="fade-up"  data-aos-duration="2000">
              Platform pembuatan undangan pernikahan online atau undangan pernikahan digital atau undangan digital dalam 
              bentuk website yang langsung jadi,undangan pernikahan video,dan undangan pernikahan gambar digital.
              </p>
            </div>
            <div className="mb-15 p-4 md:w-1/2" >
              <div className="rounded-md shadow-md overflow-hidden" data-aos="zoom-in" data-aos-duration="1200"> 
                <img src={web2} alt="Todo-List" width="w-full" />
              </div>
              <h3 className="font-semibold text-base text-dark uppercase mt-4 mb-1 lg:text-2xl" data-aos="fade-up"  data-aos-duration="2000">
                Administrator Aqadnica
              </h3>
              <p className="font-normal text-sm text-secondary text-justify lg:text-base" data-aos="fade-up"  data-aos-duration="2000">
                Halaman tampilan admin website aqadnica menggunakan framework codeigniter yang dapat melihat total keuntungan, total user dan invoice .
              </p>
            </div>
            <div className="mb-5 p-4 md:w-1/2" >
              <div className="rounded-md shadow-md overflow-hidden" data-aos="zoom-in" data-aos-duration="1200">
                <img src={web3} alt="Web Movies" width="w-full" />
              </div>
              <h3 className="font-semibold text-base text-dark uppercase mt-4 mb-1 lg:text-2xl hover:text-cpyellow" data-aos="fade-up"  data-aos-duration="2000">
                <a href="https://github.com/dreyan312/Density-Based-Spatial-Clustering-of-Application-with-Noise.git">
                Clustering DBSCAN
                </a>
              </h3>
              <p className="font-normal text-sm text-secondary text-justify lg:text-base" data-aos="fade-up"  data-aos-duration="2000">
                Algoritma DBSCAN yang dapat mengkluster, mengelompokkan, dan merepresentasikan data-data rekaman hasil GPS 
Suspek Covid-19 dengan menggunakan algoritma DBSCAN, sehingga data-data dapat dikelompokan bedasarkan kepadatan titik perekaman dan dari setiap cluster dapat diketahui titik tengah dengan menggunakan rumus rata-rata.
              </p>
            </div>
            {/* <div className="mb-5 p-4 md:w-1/2" >
              <div className="rounded-md shadow-md overflow-hidden" data-aos="zoom-in" data-aos-duration="1200">
                <img src={Porto2} alt="Todo-List" width="w-full" />
              </div>
              <h3 className="font-semibold text-base text-dark uppercase mt-4 mb-1 lg:text-2xl" data-aos="fade-up"  data-aos-duration="2000">
                Sistem pencarian kalimat utama
              </h3>
              <p className="font-normal text-sm text-secondary text-justify lg:text-base" data-aos="fade-up"  data-aos-duration="2000">
                Sistem Pencarian Kalimat Utama yang menggunakan metode TF-IDF
                (Term Frequency-Inverse Document Frequency) dan MMR (Maximal
                Marginal Relevance). Dengan menggunakan teknik ini, sistem dapat
                mengidentifikasi dan menyoroti kalimat-kalimat utama dalam teks,
                sehingga memudahkan pengguna dalam memahami informasi secara
                cepat dan efektif.
              </p>
            </div>  */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portofolio;
